import moment from 'moment';

export const formatHeaderDate = (date: string) => {
  return moment(date).format('D MMM');
};

export const formatHeaderDateMobile = (date: string) => {
  return moment(date).format('D');
};
